import { Cdn } from 'utils/assets'

export const GOOGLE_SCOPES =
  'https://www.googleapis.com/auth/classroom.courses.readonly https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile'

export const LOGO_GOOGLE = Cdn.getImageUrl('logos/icon-google.svg')
export const LOGO_MICROSOFT = Cdn.getImageUrl('logos/icon-microsoft.svg')
export const LOGO_LEX = Cdn.getImageUrl('logos/icon-lex.png')
